import React from "react";
import AboutMe from "./AboutMe";

const Experience = () => {
  return(
<AboutMe />
  )
};

export default Experience;
